// import { TweenMax, Bounce, Back, Circ, Elastic, Expo, Sine, SlowMo, Linear, Power0, Power1, Power2, Power3, Power4, TimelineLite, TimelineMax, Draggable, ScrollToPlugin, CSSPlugin, Cubic } from 'gsap';
// import ScrollMagic from 'scrollmagic';
// import 'scrollmagic/plugins'

import $ from 'jquery';


import ScrollMagic from 'ScrollMagic'
import 'animation.gsap'
import 'debug.addIndicators'


global.jQuery = require('jquery');



// require('scrollmagic/scrollmagic/minified/plugins/animation.gsap.min.js')
// require('../external/animation.gsap.min.js')
// require('../external/animation.velocity.min.js')
// require('../external/debug.addIndicators.min.js')

// const ScrollMagic = require('ScrollMagic');
// var ScrollMagic = require('./third_party/scrollmagic/scrollmagic/minified/ScrollMagic.min.js');
// require('./third_party/scrollmagic/scrollmagic/minified/plugins/animation.gsap.min.js');
// require('./third_party/scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min.js');
// const TimelineMax = require('TimelineMax');




$(function(){

  // MOUSE GRAPHIC

  var controllerMouseGraphic = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .78,
      duration: '7%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: '.mouse_graphic'
  })
  .setTween('.mouse_graphic', 1, {opacity: 0, border: '0px solid black', animation: 'none'})
  // .addIndicators()
  .addTo(controllerMouseGraphic);



  // PINNED NAV BARS

  // 1

  var controllerPinnedNav_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '1%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.link_container'
      })
      .setTween('.pinned_nav_bar', 1, {
        opacity: 1
      })
      // .addIndicators()
      .addTo(controllerPinnedNav_1);


  var controllerPinnedNav_2 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '1%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.link_container'
      })
      .setTween('.link_container', 1, {
        opacity: 0,
        // height: '40px'
      })
      // .addIndicators()
      .addTo(controllerPinnedNav_2);

  // background color: pinned nav bar
  var controllerPinnedNav_3 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '1%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_main .scrollMarker'
      })
      .setTween('.pinned_nav_bar', 1, {
        backgroundColor: 'black'
      })
      // .addIndicators()
      .addTo(controllerPinnedNav_3);


  // 2

  var controllerPinnedNav_2__1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .425,
      duration: '12%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.canvas_overlay_inner'
      })
      .setTween('.pinned_nav_bar_2', 1, {
        opacity: 1,
        top: 0
      })
      // .addIndicators()
      .addTo(controllerPinnedNav_2__1);


  // var controllerPinnedNav_2__2 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: 0,
  //     duration: '1%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '.link_container'
  //     })
  //     .setTween('.link_container', 1, {
  //       opacity: 0,
  //       // height: '40px'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerPinnedNav_2__2);
  //
  // // background color: pinned nav bar
  // var controllerPinnedNav_2__3 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: 0,
  //     duration: '1%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '.navigation_main .scrollMarker'
  //     })
  //     .setTween('.pinned_nav_bar_2', 1, {
  //       backgroundColor: 'black'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerPinnedNav_2__3);



// =================================================================

      // Bonus: change .overlay z-index while we're at it
      // NOTE: This will probably have to be moved later

      var controllerOverlay_zIndex = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .99,
          duration: '1%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '.navigation_main .scrollMarker'
          })
          .setTween('.overlay', 1, {
            zIndex: '-100'
          })
          // .addIndicators()
          .addTo(controllerOverlay_zIndex);

// =================================================================


  // background color: main navigation
  var controllerPinnedNav_4 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '1%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_main .scrollMarker'
      })
      .setTween('.pinned_nav_bar', 1, {
        backgroundColor: 'black'
      })
      // .addIndicators()
      .addTo(controllerPinnedNav_4);




  // NOTE: RESPONSIVE DESIGN

  // .menu_links_responsive__1
  // min-width: 1178px =======================================
  // NOTE: this moves the menu links from their "bubbles" to their correct position (on right)

  // apps
  var controllerPinnedNavLinks_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_main .scrollMarker'
      })
      .setTween('#menu_link_Apps_r1', 1, {
        left: '66vw',
        // color: '#1A6FA6'
      })
      // .addIndicators()
      .addTo(controllerPinnedNavLinks_1);

  // motion graphics
  var controllerPinnedNavLinks_2 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '16%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_main .scrollMarker'
      })
      .setTween('#menu_link_MotionGraphics_r1', 1, {
        left: '73vW',
        // color: '#1A6FA6'
      })
      // .addIndicators()
      .addTo(controllerPinnedNavLinks_2);

  // digital art
  var controllerPinnedNavLinks_3 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '12%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_main .scrollMarker'
      })
      .setTween('#menu_link_DigitalArt_r1', 1, {
        left: '82vW',
        // color: '#1A6FA6'
      })
      // .addIndicators()
      .addTo(controllerPinnedNavLinks_3);

  // music
  var controllerPinnedNavLinks_4 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
      duration: '8%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_main .scrollMarker'
      })
      .setTween('#menu_link_Music_r1', 1, {
        left: '88vW',
        // color: '#1A6FA6'
      })
      // .addIndicators()
      .addTo(controllerPinnedNavLinks_4);



  // nav graphics

  var controllerNavLinks_Apps_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .9,
      duration: '60%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#link_Apps'
      })
      .setTween('#link_Apps', 1, {
        // width: '50px',
        // height: '50px',
        width: '4vw',
        height: '4vw',
        // backgroundColor: 'black',
        // top: '2vH'
      })
      // .addIndicators()
      .addTo(controllerNavLinks_Apps_1);

      var controllerNavLinks_Apps_2 = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .85,
          duration: '45%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#link_Apps .scrollMarker'
          })
          .setTween('#link_Apps', 0.5, {
            // width: '150px',
            // height: '150px',
            width: '12vw',
            height: '12vw',
            backgroundColor: 'black',
            top: '2vH',
            fontSize: '1vw',
            left: '25vW'
          })
          // .addIndicators()
          .addTo(controllerNavLinks_Apps_2);



  var controllerNavLinks_MotionGraphics_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .9,
      duration: '40%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#link_MotionGraphics'
      })
      .setTween('#link_MotionGraphics', 1, {
        width: '4vw',
        height: '4vw',
        // backgroundColor: 'black',
        // top: '2vH'
      })
      // .addIndicators()
      .addTo(controllerNavLinks_MotionGraphics_1);

      var controllerNavLinks_MotionGraphics_2 = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .9,
          duration: '40%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#link_MotionGraphics .scrollMarker'
          })
          .setTween('#link_MotionGraphics', 0.5, {
            width: '12vw',
            height: '12vw',
            backgroundColor: 'black',
            top: '2vH',
            fontSize: '1vw',
            left: '40vW'
          })
          // .addIndicators()
          .addTo(controllerNavLinks_MotionGraphics_2);



  var controllerNavLinks_DigitalArt_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .9,
      duration: '40%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#link_DigitalArt'
      })
      .setTween('#link_DigitalArt', 1, {
        width: '4vw',
        height: '4vw',
        // backgroundColor: 'black',
        // top: '2vH'
      })
      // .addIndicators()
      .addTo(controllerNavLinks_DigitalArt_1);

      var controllerNavLinks_DigitalArt_2 = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .85,
          duration: '20%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#link_DigitalArt .scrollMarker'
          })
          .setTween('#link_DigitalArt', 0.5, {
            width: '12vw',
            height: '12vw',
            backgroundColor: 'black',
            top: '2vH',
            fontSize: '1vw',
            left: '55vW'
          })
          // .addIndicators()
          .addTo(controllerNavLinks_DigitalArt_2);



  var controllerNavLinks_Music_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .9,
      duration: '40%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#link_Music'
      })
      .setTween('#link_Music', 1, {
        width: '4vw',
        height: '4vw',
        // backgroundColor: 'black',
        // top: '2vH'
      })
      // .addIndicators()
      .addTo(controllerNavLinks_Music_1);

      var controllerNavLinks_Music_2 = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .9,
          duration: '20%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#link_Music .scrollMarker'
          })
          .setTween('#link_Music', 0.5, {
            width: '12vw',
            height: '12vw',
            backgroundColor: 'black',
            top: '2vH',
            fontSize: '1vw',
            left: '70vW'
          })
          // .addIndicators()
          .addTo(controllerNavLinks_Music_2);



  // opacity: canvas overlay
  var controllerCanvasOverlay = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '40%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.navigation_scrollMarker'
      })
      .setTween('.canvas_overlay_inner', 1, {
        opacity: 0.9
      })
      // .addIndicators()
      .addTo(controllerCanvasOverlay);


///////////////////////////////////////////////
  // COMPONENTS ===============================

  // Apps
  var controllerComponents_Apps_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .7,
      duration: '90%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '.apps'
      })
      .setTween('.apps', 1, {
        marginTop: '0'
      })
      // .addIndicators()
      .addTo(controllerComponents_Apps_1);




  // CALLBACK SPACERS (nav menu link toggles) =========================

  // NOTE: For each component, "RESPONSIVE 1" moves the links from the right to the center (DISABLE) ->
  //            in favor of menu headers ("RESPONSIVE 2 and 3"))


  // About Me (NOTE: this is a utility element to keep other headers in line)

  // RESPONSIVE 2 ======================

  // set
  var controllerSpacer_2__AboutMe = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .35,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_aboutMe'
      })
      .setTween('.menu_link_header_AboutMe', 1, {
        display: 'block',
        top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__AboutMe);


  // Apps

  // RESPONSIVE 1 ======================

  // // set
  // var controllerSpacer_1__Apps = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .5,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_apps'
  //     })
  //     .setTween('#menu_link_Apps_r1', 1, {
  //       left: '44vw',
  //       fontSize: '1.6rem',
  //       top: '1vh',
  //       // width: 'auto'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__Apps);

  // RESPONSIVE 2 ======================

  // reset previous
  var controllerSpacer_2__Apps_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 1,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_apps'
      })
      .setTween('.menu_link_header_AboutMe', 1, {
        top: '5vh',
        opacity: 0,
        display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__Apps_resetPrevious);

  // set
  var controllerSpacer_2__Apps = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_apps'
      })
      .setTween('.menu_link_header_Apps', 1, {
        display: 'block',
        top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__Apps);


  // RESPONSIVE 3 ======================

  // set
  var controllerSpacer_3__Apps = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_apps'
      })
      .setTween(['#menu_link_MotionGraphics_r3', '#menu_link_DigitalArt_r3', '#menu_link_Music_r3'], 1, {
        opacity: .25
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__Apps);


  // Motion Graphics

  // RESPONSIVE 1 ======================

  // // reset previous
  // var controllerSpacer_1__MotionGraphics_resetPrevious = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .5,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_motionGraphics'
  //     })
  //     .setTween('#menu_link_Apps_r1', 1, {
  //       left: '66vw',
  //       fontSize: '.8rem',
  //       top: '2vh'
  //       // width: '150px'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__MotionGraphics_resetPrevious);
  //
  // // set
  // var controllerSpacer_1__MotionGraphics_set = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .3,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_motionGraphics'
  //     })
  //     .setTween('#menu_link_MotionGraphics_r1', 1, {
  //       left: '44vw',
  //       fontSize: '1.6rem',
  //       top: '1vh',
  //       width: 'auto'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__MotionGraphics_set);


  // RESPONSIVE 2 ======================

  // reset previous
  var controllerSpacer_2__MotionGraphics_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_motionGraphics'
      })
      .setTween('.menu_link_header_Apps', 1, {
        top: '5vh',
        opacity: 0,
        display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__MotionGraphics_resetPrevious);

  // set
  var controllerSpacer_2__MotionGraphics_set = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .3,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_motionGraphics'
      })
      .setTween('.menu_link_header_MotionGraphics', 1, {
        display: 'block',
        top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__MotionGraphics_set);


  // RESPONSIVE 3 ======================

  // reset previous
  var controllerSpacer_3__MotionGraphics_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_motionGraphics'
      })
      .setTween('#menu_link_Apps_r3', 1, {
        opacity: .25,
        // display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__MotionGraphics_resetPrevious);

  // set
  var controllerSpacer_3__MotionGraphics_set = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .3,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_motionGraphics'
      })
      .setTween('#menu_link_MotionGraphics_r3', 1, {
        // display: 'inline-block',
        // top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__MotionGraphics_set);



  // Digital Art


  // RESPONSIVE 1 ======================

  // // reset previous
  // var controllerSpacer_1__DigitalArt_resetPrevious = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .5,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_digitalArt'
  //     })
  //     .setTween('#menu_link_MotionGraphics_r1', 1, {
  //       left: '73vw',
  //       fontSize: '.8rem',
  //       top: '2vh',
  //       width: '150px'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__DigitalArt_resetPrevious);
  //
  //
  // // set
  // var controllerSpacer_1__DigitalArt_set = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .3,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_digitalArt'
  //     })
  //     .setTween('#menu_link_DigitalArt_r1', 1, {
  //       left: '44vw',
  //       fontSize: '1.6rem',
  //       top: '1vh',
  //       width: 'auto'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__DigitalArt_set);


  // RESPONSIVE 2 ======================

  // reset previous
  var controllerSpacer_2__DigitalArt_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_digitalArt'
      })
      .setTween('.menu_link_header_MotionGraphics', 1, {
        top: '5vh',
        opacity: 0,
        display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__DigitalArt_resetPrevious);


  // set
  var controllerSpacer_2__DigitalArt_set = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .3,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_digitalArt'
      })
      .setTween('.menu_link_header_DigitalArt', 1, {
        display: 'block',
        top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__DigitalArt_set);


  // RESPONSIVE 3 ======================

  // reset previous
  var controllerSpacer_3__DigitalArt_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_digitalArt'
      })
      .setTween('#menu_link_MotionGraphics_r3', 1, {
        // top: '5vh',
        opacity: .25,
        // display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__DigitalArt_resetPrevious);


  // set
  var controllerSpacer_3__DigitalArt_set = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .3,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_digitalArt'
      })
      .setTween('#menu_link_DigitalArt_r3', 1, {
        // display: 'inline-block',
        // top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__DigitalArt_set);







  // Music


  // RESPONSIVE 1 ======================

  // // reset previous
  // var controllerSpacer_1__Music_resetPrevious = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .5,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_music'
  //     })
  //     .setTween('#menu_link_DigitalArt_r1', 1, {
  //       left: '82vw',
  //       fontSize: '.8rem',
  //       top: '2vh',
  //       width: '150px'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__Music_resetPrevious);
  //
  //
  // // set
  // var controllerSpacer_1__Music_set = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .3,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_music'
  //     })
  //     .setTween('#menu_link_Music_r1', 1, {
  //       left: '44vw',
  //       fontSize: '1.6rem',
  //       top: '1vh',
  //       width: 'auto'
  //     })
  //     // .addIndicators()
  //     .addTo(controllerSpacer_1__Music_set);


  // RESPONSIVE 2 ======================

  // reset previous
  var controllerSpacer_2__Music_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_music'
      })
      .setTween('.menu_link_header_DigitalArt', 1, {
        top: '5vh',
        opacity: 0,
        display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__Music_resetPrevious);


  // set
  var controllerSpacer_2__Music_set = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .3,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_music'
      })
      .setTween('.menu_link_header_Music', 1, {
        display: 'block',
        top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__Music_set);


  // RESPONSIVE 3 ======================

  // reset previous
  var controllerSpacer_3__Music_resetPrevious = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_music'
      })
      .setTween('#menu_link_DigitalArt_r3', 1, {
        // top: '5vh',
        opacity: .25,
        // display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__Music_resetPrevious);


  // set
  var controllerSpacer_3__Music_set = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .3,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_music'
      })
      .setTween('#menu_link_Music_r3', 1, {
        // display: 'inline-block',
        // top: '1vh',
        opacity: 1
        // width: 'auto'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__Music_set);


  // Reset Menu Links


  // RESPONSIVE 1 ======================

  // reset previous
  var controllerSpacer_1__ResetMenuLinks = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_resetMenuLinks'
      })
      .setTween('#menu_link_Music_r1', 1, {
        left: '88vw',
        fontSize: '.8rem',
        top: '2vh',
        width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_1__ResetMenuLinks);


  // // set
  // var controllerSpacer_MoreAboutMe_set = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .3,
  //     duration: '20%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '#callbackSpacer_music'
  //     })
  //     .setTween('#menu_link_MoreAboutMe', 1, {
  //       left: '44vw'
  //     })
      // .addIndicators()
  //     .addTo(controllerSpacer_MoreAboutMe_set);


  // RESPONSIVE 2 ======================

  // reset previous
  var controllerSpacer_2__ResetMenuLinks = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_resetMenuLinks'
      })
      .setTween('.menu_link_header_Music', 1, {
        top: '5vh',
        opacity: 0,
        display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_2__ResetMenuLinks);


  // RESPONSIVE 3 ======================

  // reset previous
  var controllerSpacer_3__ResetMenuLinks = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .5,
      duration: '20%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: '#callbackSpacer_resetMenuLinks'
      })
      .setTween('#menu_link_Music_r3', 1, {
        // top: '5vh',
        opacity: .25,
        // display: 'none'
        // width: '150px'
      })
      // .addIndicators()
      .addTo(controllerSpacer_3__ResetMenuLinks);



///////////////////////////////////////////////


  // // WORK HEADER
  //
  //
  // // FLIP LETTERS
  //
  // var controllerWorkHeader_1 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: 1,
  //     duration: '50%'
  //   }
  // });
  // new ScrollMagic.Scene({
  //   triggerElement: ".work__header p",
  // })
  // .setTween(".work__header p", 1, {margin: '10px'})
  // // .addIndicators()
  // .addTo(controllerWorkHeader_1);
  //
  //
  // // CHANGE TEXT COLOR FROM WHITE TO BLACK
  //
  // // (header)
  // var controllerWorkHeader_2 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .4,
  //     duration: '50%'
  //   }
  // });
  // new ScrollMagic.Scene({
  //   triggerElement: ".work__header",
  // })
  // .setTween(".work__header", 1, {color: "black"})
  // // .addIndicators()
  // .addTo(controllerWorkHeader_2);
  //
  // // (text)
  // var controllerWorkText_1 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .4,
  //     duration: '50%'
  //   }
  // });
  // new ScrollMagic.Scene({
  //   triggerElement: "#work__text",
  // })
  // .setTween("#work__text", 1, {color: "black"})
  // // .addIndicators()
  // .addTo(controllerWorkText_1);


// PROJECTS


  // CHANGE BACKGROUND COLOR TO (WHITE / BLUE)

  var controllerEnclosure_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0, // NOTE: return to '0' after testing
      duration: '80%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: ".secondary-enclosure",
  })
  .setTween(".secondary-enclosure", 1, {
    // backgroundColor: "#1976AE", opacity: 1
    backgroundColor: "black", opacity: 1
  })
  // .addIndicators()
  .addTo(controllerEnclosure_1);

  // adjust .overlay z-index when scrolling
  // var controllerOverlay_zIndex = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: .2,
  //     duration: '100%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: '.overlay',
  //     })
  //     .setTween('.overlay', 1, {
  //       zIndex: '-100'
  //     })
      // .addIndicators()
  //     .addTo(controllerOverlay_zIndex);





  // var controllerApps_1 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: 1,
  //     duration: '30%'
  //   }
  // });
  // new ScrollMagic.Scene({
  //   triggerElement: "#work",
  // })
  // .setTween("#work", 1, {
  //   backgroundColor: "white", opacity: 1
  // })
  // // .addIndicators()
  // .addTo(controllerApps_1);


// ABOUT ME


  // TRANSITION PORTRAITS

  // var controllerAboutMePortrait_1 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: 0,
  //     duration: '9%'
  //   }
  // });
  // new ScrollMagic.Scene({
  //   triggerElement: "#about_me__text",
  // })
  // .setTween("#portrait_1", 1, {opacity: 0})
  // // .addIndicators()
  // .addTo(controllerAboutMePortrait_1);


  // CHANGE TEXT OPACITY + TOP

  var controllerAboutMeText_1 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .6,
      duration: '95%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: ".about",
      })
      .setTween("#about_me_description", 1, {
        opacity: 1,
        top: '40vh'
      })
      // .addIndicators()
      .addTo(controllerAboutMeText_1);

  // CHANGE SECTION HEIGHT

  var controllerAboutMeDescriptionHeight = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 1,
      duration: '91%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: ".apps",
      })
      .setTween("#about_me_description", 0.9, {height: '0%'})
      // .addIndicators()
      .addTo(controllerAboutMeDescriptionHeight);


  var controllerAboutMeDescriptionOpacity = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .8,
      duration: '30%'
    }
  });
      new ScrollMagic.Scene({
        triggerElement: "#callbackSpacer_apps",
      })
      .setTween("#about_me_description", 0.9, {opacity: 0})
      // .addIndicators()
      .addTo(controllerAboutMeDescriptionOpacity);


  // CHANGE BACKGROUND OPACITY

  // var controllerAboutMeBackground_1 = new ScrollMagic.Controller({
  //   globalSceneOptions: {
  //     triggerHook: 0.6,
  //     duration: '50%'
  //   }
  // });
  //     new ScrollMagic.Scene({
  //       triggerElement: ".about",
  //     })
  //     .setTween(".canvas_overlay_inner", 1, {opacity: .9})
  //     // .addIndicators()
  //     .addTo(controllerAboutMeBackground_1);



// // SKILLS
//
//
//   // FADE IN HEADER TEXT
//
//   var controllerSkillsHeaderText = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .61,
//       duration: '10%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#skills",
//   })
//   .setTween("#skills", 1, {opacity: 1})
//   // .addIndicators()
//   .addTo(controllerSkillsHeaderText);
//
//
//   // FADE IN DESCRIPTION TEXT
//
//   var controllerSkillsDescriptionText = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .61,
//       duration: '10%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#skills_description",
//   })
//   .setTween("#skills_description", 1, {opacity: 1})
//   // .addIndicators()
//   .addTo(controllerSkillsDescriptionText);


// FOOTER


  // FADE IN BACKGROUND COLOR

  var controllerFooter = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .725,
      duration: '40%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#footer",
  })
  .setTween('#footer', 1, {backgroundColor: '#0B1318', opacity: 1})
  // .addIndicators()
  .addTo(controllerFooter);




//////////////////////////// FLYING ICONS ////////////////////////////////


// PROJECTS

  // TSKLST

  // iOS
  var controllerFlyingIcons_Tsklst_iOS = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .73,
      duration: '60%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Tsklst_iOS",
  })
  .setClassToggle('#flyingIcon_Tsklst_iOS', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Tsklst_iOS);

  // Swift3
  var controllerFlyingIcons_Tsklst_Swift3 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .8,
      duration: '85%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Tsklst_Swift3",
  })
  .setClassToggle('#flyingIcon_Tsklst_Swift3', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Tsklst_Swift3);

  // Xcode
  var controllerFlyingIcons_Tsklst_Xcode = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .79,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Tsklst_Xcode",
  })
  .setClassToggle('#flyingIcon_Tsklst_Xcode', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Tsklst_Xcode);


  // RESIST


  // iOS
  var controllerFlyingIcons_Resist_iOS = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .73,
      duration: '75%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_iOS",
  })
  .setClassToggle('#flyingIcon_Resist_iOS', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_iOS);

  // Xcode
  var controllerFlyingIcons_Resist_Xcode = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .79,
      duration: '80%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_Xcode",
  })
  .setClassToggle('#flyingIcon_Resist_Xcode', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_Xcode);

  // Swift3
  var controllerFlyingIcons_Resist_Swift3 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .82,
      duration: '85%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_Swift3",
  })
  .setClassToggle('#flyingIcon_Resist_Swift3', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_Swift3);

  // Angular
  var controllerFlyingIcons_Resist_Angular = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .58,
      duration: '50%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_Angular",
  })
  .setClassToggle('#flyingIcon_Resist_Angular', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_Angular);

  // Express
  var controllerFlyingIcons_Resist_Express = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .66,
      duration: '60%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_Express",
  })
  .setClassToggle('#flyingIcon_Resist_Express', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_Express);

  // Node
  var controllerFlyingIcons_Resist_Node = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .7,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_Node",
  })
  .setClassToggle('#flyingIcon_Resist_Node', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_Node);

  // Mongo
  var controllerFlyingIcons_Resist_Mongo = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .63,
      duration: '55%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Resist_Mongo",
  })
  .setClassToggle('#flyingIcon_Resist_Mongo', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Resist_Mongo);



  // TIPRO

  // iOS
  var controllerFlyingIcons_Tipro_iOS = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .73,
      duration: '60%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Tipro_iOS",
  })
  .setClassToggle('#flyingIcon_Tipro_iOS', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Tipro_iOS);

  // Swift3
  var controllerFlyingIcons_Tipro_Swift3 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .8,
      duration: '85%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Tipro_Swift3",
  })
  .setClassToggle('#flyingIcon_Tipro_Swift3', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Tipro_Swift3);

  // Xcode
  var controllerFlyingIcons_Tipro_Xcode = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .79,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_Tipro_Xcode",
  })
  .setClassToggle('#flyingIcon_Tipro_Xcode', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_Tipro_Xcode);


// THIS WEBSITE

  // React
  var controllerFlyingIcons_ThisWebsite_React = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .8,
      duration: '90%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_React",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_React', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_React);

  // Redux
  var controllerFlyingIcons_ThisWebsite_Redux = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .75,
      duration: '85%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_Redux",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_Redux', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_Redux);

  // JavaScript
  var controllerFlyingIcons_ThisWebsite_JavaScript = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .7,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_JavaScript",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_JavaScript', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_JavaScript);

  // Node
  var controllerFlyingIcons_ThisWebsite_Node = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .7,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_Node",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_Node', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_Node);

  // CSS3
  var controllerFlyingIcons_ThisWebsite_CSS3 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .6,
      duration: '65%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_CSS3",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_CSS3', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_CSS3);

  // jQuery
  var controllerFlyingIcons_ThisWebsite_jQuery = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .6,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_jQuery",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_jQuery', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_jQuery);

  // HTML5
  var controllerFlyingIcons_ThisWebsite_HTML5 = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .45,
      duration: '55%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_HTML5",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_HTML5', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_HTML5);

  // Foundation
  var controllerFlyingIcons_ThisWebsite_Foundation = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .7,
      duration: '65%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_Foundation",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_Foundation', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_Foundation);

  // AWS
  var controllerFlyingIcons_ThisWebsite_AWS = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .60,
      duration: '60%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_AWS",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_AWS', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_AWS);

  // Babel
  var controllerFlyingIcons_ThisWebsite_Babel = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .8,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_Babel",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_Babel', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_Babel);

  // Webpack
  var controllerFlyingIcons_ThisWebsite_Webpack = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: .65,
      duration: '70%'
    }
  });
  new ScrollMagic.Scene({
    triggerElement: "#flyingIcon_ThisWebsite_Webpack",
  })
  .setClassToggle('#flyingIcon_ThisWebsite_Webpack', 'slide-in')
  // .addIndicators()
  .addTo(controllerFlyingIcons_ThisWebsite_Webpack);


// // SKILLS
//
//   // JavaScript
//   var controllerFlyingIcons_Skills_JavaScript = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '100%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_JavaScript",
//   })
//   .setTween('#flyingIcon_Skills_JavaScript', 1, {opacity: 1, top: 0})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_JavaScript);
//
//   // Swift3
//   var controllerFlyingIcons_Skills_Swift3 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .99,
//       duration: '90%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Swift3",
//   })
//   .setTween('#flyingIcon_Skills_Swift3', 1, {opacity: 1, top: '100px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Swift3);
//
//   // HTML5
//   var controllerFlyingIcons_Skills_HTML5 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .83,
//       duration: '70%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_HTML5",
//   })
//   .setTween('#flyingIcon_Skills_HTML5', 1, {opacity: 1, top: '185px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_HTML5);
//
//   // CSS3
//   var controllerFlyingIcons_Skills_CSS3 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '60%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_CSS3",
//   })
//   .setTween('#flyingIcon_Skills_CSS3', 1, {opacity: 1, top: '195px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_CSS3);
//
//   // React
//   var controllerFlyingIcons_Skills_React = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .98,
//       duration: '100%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_React",
//   })
//   .setTween('#flyingIcon_Skills_React', 1, {opacity: 1, top: '105px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_React);
//
//   // Redux
//   var controllerFlyingIcons_Skills_Redux = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .99,
//       duration: '68%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Redux",
//   })
//   .setTween('#flyingIcon_Skills_Redux', 1, {opacity: 1, top: '300px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Redux);
//
//   // Node
//   var controllerFlyingIcons_Skills_Node = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '65%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Node",
//   })
//   .setTween('#flyingIcon_Skills_Node', 1, {opacity: 1, top: '295px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Node);
//
//   // jQuery
//   var controllerFlyingIcons_Skills_jQuery = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '45%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_jQuery",
//   })
//   .setTween('#flyingIcon_Skills_jQuery', 1, {opacity: 1, top: '310px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_jQuery);
//
//   // Angular
//   var controllerFlyingIcons_Skills_Angular = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '60%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Angular",
//   })
//   .setTween('#flyingIcon_Skills_Angular', 1, {opacity: 1, top: '390px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Angular);
//
//   // Express
//   var controllerFlyingIcons_Skills_Express = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .89,
//       duration: '40%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Express",
//   })
//   .setTween('#flyingIcon_Skills_Express', 1, {opacity: 1, top: '410px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Express);
//
//   // Xcode
//   var controllerFlyingIcons_Skills_Xcode = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '90%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Xcode",
//   })
//   .setTween('#flyingIcon_Skills_Xcode', 1, {opacity: 1, top: '60px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Xcode);
//
//   // Foundation
//   var controllerFlyingIcons_Skills_Foundation = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '110%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Foundation",
//   })
//   .setTween('#flyingIcon_Skills_Foundation', 1, {opacity: 1, top: '10px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Foundation);
//
//   // Webpack
//   var controllerFlyingIcons_Skills_Webpack = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '75%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Webpack",
//   })
//   .setTween('#flyingIcon_Skills_Webpack', 1, {opacity: 1, top: '185px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Webpack);
//
//   // AWS
//   var controllerFlyingIcons_Skills_AWS = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '90%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_AWS",
//   })
//   .setTween('#flyingIcon_Skills_AWS', 1, {opacity: 1, top: '90px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_AWS);
//
//   // Mongo
//   var controllerFlyingIcons_Skills_Mongo = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '90%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Mongo",
//   })
//   .setTween('#flyingIcon_Skills_Mongo', 1, {opacity: 1, top: '250px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Mongo);
//
//   // Babel
//   var controllerFlyingIcons_Skills_Babel = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '90%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_Babel",
//   })
//   .setTween('#flyingIcon_Skills_Babel', 1, {opacity: 1, top: '290px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_Babel);
//
//   // OSX
//   var controllerFlyingIcons_Skills_OSX = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '80%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#flyingIcon_Skills_OSX",
//   })
//   .setTween('#flyingIcon_Skills_OSX', 1, {opacity: 1, top: '370px'})
//   // .addIndicators()
//   .addTo(controllerFlyingIcons_Skills_OSX);


//////////////// APPS // GLOBAL SCROLLING /////////////////

  // TSKLST

    // header
    var controllerAppsGlobalScroll__Tsklst_header = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .99,
        duration: '20%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '#P1_Tsklst_project_header',
        })
        .setTween('#P1_Tsklst_project_header', 1, {marginTop: '0'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Tsklst_header);


        // var controllerAppsGlobalScroll__Tsklst_button = new ScrollMagic.Controller({
        //   globalSceneOptions: {
        //     triggerHook: 0.6,
        //     duration: '20%'
        //   }
        // });
        //     new ScrollMagic.Scene({
        //       triggerElement: '.description__code_button',
        //     })
        //     .setTween('.description__code_button', 1, {opacity: 1})
        //     // .addIndicators()
        //     .addTo(controllerAppsGlobalScroll__Tsklst_button);



    // description
    var controllerAppsGlobalScroll__Tsklst_description = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .6,
        duration: '30%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '#P1_Tsklst_description',
        })
        .setTween('#P1_Tsklst_description', 1, {marginLeft: '0'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Tsklst_description);


      // description inner enclosure
      var controllerAppsGlobalScroll__Tsklst_descriptionInnerEnclosure = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .3,
          duration: '100%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#P1_Tsklst_description__inner_enclosure',
          })
          .setTween('#P1_Tsklst_description__inner_enclosure', 0.5, {paddingTop: '250px'})
          // .addIndicators()
          .addTo(controllerAppsGlobalScroll__Tsklst_descriptionInnerEnclosure);


    // images
    var controllerAppsGlobalScroll__Tsklst_images = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .75,
        duration: '40%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '.tsklst_images',
        })
        .setTween('.tsklst_images', 1, {left: '40vW'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Tsklst_images);


  // RESIST

    // header
    var controllerAppsGlobalScroll__Resist_header = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .95,
        duration: '20%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '#P3_Resist_project_header',
        })
        .setTween('#P3_Resist_project_header', 1, {marginTop: '0'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Resist_header);


    // description
    var controllerAppsGlobalScroll__Resist_description = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .6,
        duration: '30%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '#P3_Resist_description',
        })
        .setTween('#P3_Resist_description', 1, {marginLeft: '58%'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Resist_description);


      // description inner enclosure
      var controllerAppsGlobalScroll__Resist_descriptionInnerEnclosure = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .3,
          duration: '100%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#P3_Resist_description__inner_enclosure',
          })
          .setTween('#P3_Resist_description__inner_enclosure', 0.5, {paddingTop: '250'})
          // .addIndicators()
          .addTo(controllerAppsGlobalScroll__Resist_descriptionInnerEnclosure);


    // images
    var controllerAppsGlobalScroll__Resist_images = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .75,
        duration: '40%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '.resist_images',
        })
        .setTween('.resist_images', 1, {right: '41vW'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Resist_images);


  // TIPRO

    // header
    var controllerAppsGlobalScroll__Tipro_header = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .95,
        duration: '20%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '#P2_Tipro_project_header',
        })
        .setTween('#P2_Tipro_project_header', 1, {marginTop: '0'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Tipro_header);


    // description
    var controllerAppsGlobalScroll__Tipro_description = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .6,
        duration: '30%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '#P2_Tipro_description',
        })
        .setTween('#P2_Tipro_description', 1, {marginLeft: '0'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Tipro_description);


      // description inner enclosure
      var controllerAppsGlobalScroll__Tipro_descriptionInnerEnclosure = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: .3,
          duration: '100%'
        }
      });
          new ScrollMagic.Scene({
            triggerElement: '#P2_Tipro_description__inner_enclosure',
          })
          .setTween('#P2_Tipro_description__inner_enclosure', 0.5, {paddingTop: '250px'})
          // .addIndicators()
          .addTo(controllerAppsGlobalScroll__Tipro_descriptionInnerEnclosure);


    // images
    var controllerAppsGlobalScroll__Tipro_images = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .75,
        duration: '40%'
      }
    });
        new ScrollMagic.Scene({
          triggerElement: '.tipro_images',
        })
        .setTween('.tipro_images', 1, {left: '40vW'})
        // .addIndicators()
        .addTo(controllerAppsGlobalScroll__Tipro_images);







//////////////// BACKGROUND VIDEOS -- SCROLLING AUTOPLAY /////////////////
// NOTE: autoplay is buggy on smaller screens
// *** bug: autoplay doesn't work on initial enter ***
        // < 500 (doesn't seem to work)
        // 500 ~ 550 (very buggy)
        // 550 ~ 600 (little buggy)
        // >= 600 (good)


  // TSKLST

    // enter
    var controllerVideoEnter_Tsklst = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .9,
        duration: '99.5%'
      }
    });
    new ScrollMagic.Scene({
      triggerElement: "#video_1",
    })
    .on('enter', function(e){
      var video = document.getElementById('video_1')
      if (video) {
        video.play()
      }
    })
    // .addIndicators()
    .addTo(controllerVideoEnter_Tsklst);

    // leave
    var controllerVideoLeave_Tsklst = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .5,
        duration: '99.5%'
      }
    });
    new ScrollMagic.Scene({
      triggerElement: "#video_1",
    })
    .on('leave', function(){
      console.log("inside .on('leave')...")
      var video = document.getElementById('video_1')
      if (video) {
        video.pause()
      }
    })
    // .addIndicators()
    .addTo(controllerVideoLeave_Tsklst);


    // RESIST

    // enter
    var controllerVideoEnter_Resist = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .9,
        duration: '99.5%'
      }
    });
    new ScrollMagic.Scene({
      triggerElement: "#video_2",
    })
    .on('enter', function(e){
      var video = document.getElementById('video_2')
      if (video) {
        video.play()
      }
    })
    // .addIndicators()
    .addTo(controllerVideoEnter_Resist);

    // leave
    var controllerVideoLeave_Resist = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .5,
        duration: '99.5%'
      }
    });
    new ScrollMagic.Scene({
      triggerElement: "#video_2",
    })
    .on('leave', function(){
      console.log("inside .on('leave')...")
      var video = document.getElementById('video_2')
      if (video) {
        video.pause()
      }
    })
    // .addIndicators()
    .addTo(controllerVideoLeave_Resist);


    // TIPRO

    // enter
    var controllerVideoEnter_Tipro = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .9,
        duration: '99.5%'
      }
    });
    new ScrollMagic.Scene({
      triggerElement: "#video_3",
    })
    .on('enter', function(e){
      var video = document.getElementById('video_3')
      if (video) {
        video.play()
      }
    })
    // .addIndicators()
    .addTo(controllerVideoEnter_Tipro);

    // leave
    var controllerVideoLeave_Tipro = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: .5,
        duration: '99.5%'
      }
    });
    new ScrollMagic.Scene({
      triggerElement: "#video_3",
    })
    .on('leave', function(){
      var video = document.getElementById('video_3')
      if (video) {
        video.pause()
      }
    })
    // .addIndicators()
    .addTo(controllerVideoLeave_Tipro);


// /////////////////////////// SCREENSHOT IMAGES //////////////////////////
//
//
//   // TSKLST
//
//   var controllerScreenShotTsklst_1 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '96%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P1_Tsklst_image_1",
//   })
//   .setClassToggle('#P1_Tsklst_image_1', 'slide-in')
//   // .addIndicators()
//   .addTo(controllerScreenShotTsklst_1);
//
//   var controllerScreenShotTsklst_3 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '73%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P1_Tsklst_image_3",
//   })
//   .setClassToggle('#P1_Tsklst_image_3', 'slide-in-1')
//   // .addIndicators()
//   .addTo(controllerScreenShotTsklst_3);
//
//   var controllerScreenShotTsklst_4 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 1,
//       duration: '48%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P1_Tsklst_image_4",
//   })
//   .setClassToggle('#P1_Tsklst_image_4', 'slide-in-3')
//   // .addIndicators()
//   .addTo(controllerScreenShotTsklst_4);
//
//
//   // RESIST
//
//   var controllerScreenShotResist_1 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .85,
//       duration: '82%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P3_Resist_image_2",
//   })
//   .setClassToggle('#P3_Resist_image_2', 'slide-in-A')
//   // .addIndicators()
//   .addTo(controllerScreenShotResist_1);
//
//   var controllerScreenShotResist_2 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .9,
//       duration: '36%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P3_Resist_image_1",
//   })
//   .setClassToggle('#P3_Resist_image_1', 'slide-in')
//   // .addIndicators()
//   .addTo(controllerScreenShotResist_2);
//
//
//   // TIPRO
//
//   var controllerScreenShotTipro_1 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: 78,
//       duration: '96%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P2_Tipro_image_2",
//   })
//   .setClassToggle('#P2_Tipro_image_2', 'slide-in-3')
//   // .addIndicators()
//   .addTo(controllerScreenShotTipro_1);
//
//   var controllerScreenShotTipro_2 = new ScrollMagic.Controller({
//     globalSceneOptions: {
//       triggerHook: .8,
//       duration: '52%'
//     }
//   });
//   new ScrollMagic.Scene({
//     triggerElement: "#P2_Tipro_image_1",
//   })
//   .setClassToggle('#P2_Tipro_image_1', 'slide-in-A')
//   // .addIndicators()
//   .addTo(controllerScreenShotTipro_2);





}) // end function



// WEBPACK FOOTER //
// ./src/js_animations/scrollMagic.js